import { AfterViewInit, ChangeDetectorRef, Component, Directive, ElementRef, inject, OnDestroy, OnInit, QueryList, ViewChild, ViewChildren, input, Input } from '@angular/core'
import { Router } from '@angular/router'
import { NgbPopover, NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap'
import { Store } from '@ngrx/store'
import { Subscription } from 'rxjs'
import { SavedSearchService } from 'src/app/services/saved-search.service'
import { selectUser } from 'src/app/state/user.reducer'
import { followOptionsByArea } from '../../follow-options'
import { StickyPopoverDirective } from '../../directives/sticky-popover'
import { NgIcon, provideIcons } from '@ng-icons/core'
import { bootstrapAlarm, bootstrapAlarmFill } from '@ng-icons/bootstrap-icons'


@Component({
  selector: 'followable-link',
  imports: [
    NgbPopoverModule,
    NgIcon,
    StickyPopoverDirective,
  ],
  templateUrl: './followable-link.component.html',
  styleUrl: './followable-link.component.scss',
  providers: [provideIcons({ bootstrapAlarm, bootstrapAlarmFill })]
})
export class FollowableLinkComponent implements AfterViewInit, OnDestroy {
  readonly articleid = input<number>(0)
  readonly area = input<string>('')
  readonly label = input<string>('')
  @Input() clickable: boolean = true
  readonly size = input<string>('14px')

  @ViewChild('popover') popover: NgbPopover | undefined

  public user$: Subscription = Subscription.EMPTY
  public followArticleSearch: any | undefined = undefined

  public icon = 'bootstrapAlarm'
  public title = ''
  public titleDescription = ''
  public popoverContent = ''

  public router = inject(Router)
  public store = inject(Store)
  public savedSearchService = inject(SavedSearchService)
  private cdr = inject(ChangeDetectorRef)

  public words = ''
  public lastWord: string = ''
  public labelAsText: string = ''
  public wordCount: number = 0

  ngAfterViewInit(): void {
    let temporalDivElement = document.createElement("div")
    temporalDivElement.innerHTML = this.label()
    this.labelAsText = temporalDivElement.textContent || temporalDivElement.innerText || ""

    let words = this.labelAsText.split(' ')
    this.lastWord = words?.pop() ?? ''
    this.words = words?.join(' ') ?? ''
    this.wordCount = words.length

    this.user$ = this.store.select(selectUser).subscribe(user => {
      this.followArticleSearch = user?.searches?.[this.area()]?.find((search: any) => search.parameters.id == this.articleid())
      if (this.followArticleSearch ?? 0 > 0) {
        this.icon = 'bootstrapAlarmFill'
        this.title = "Unfollow"
        this.titleDescription = "You are following "
        this.popoverContent = this.labelAsText
      } else {
        this.icon = 'bootstrapAlarm'
        this.title = "Follow"
        this.titleDescription = "Follow"
        this.popoverContent = this.labelAsText
      }
      this.cdr.detectChanges()
    })
    this.cdr.detectChanges()
  }

  ngOnDestroy(): void {
    this.user$.unsubscribe()
  }

  gotoPage() {
    if (this.clickable) {
      const url = `/${this.area()}/${this.articleid()}`
      window.open(url, "_blank")
    }
  }

  followUnfollow() {
    if (this.title === 'Follow') {
      this.savedSearchService.saveSearch({
        parameters: {
          area: this.area(),
          id: this.articleid(),
          options: structuredClone(followOptionsByArea[this.area() as keyof typeof followOptionsByArea])
        },
        area: this.area(),
        type: 'follow',
        name: 'Follow: ' + this.popoverContent
      })
    } else {
      this.savedSearchService.deleteSearch(this.followArticleSearch)
    }
    this.cdr.detectChanges()
  }
}
